import React from 'react';
import ProductDetailsContent from '../../components/Products/ProductDetails/ProductDetailsContent';
import { useParams } from 'react-router-dom';

export default function ProductDetails() {
  const params = useParams();

  return (
    <div>
      <ProductDetailsContent productId={params?.id as string} />
    </div>
  );
}
